<template>
    <div>
        <div class="panel panel-default">
            <!-- Default panel contents -->
            <div class="panel-heading">SAIDAS</div>

            <ul class="list-group">
                <li class="list-group-item">
                    BLOQUEIO
                    <switche :id="'output1'" v-model="data.output1"/>
                </li>
                <li class="list-group-item" v-if="enable_output2">
                    SAÍDA 2
                    <switche :id="'output2'" v-model="data.output2"/>
                </li>
            </ul>
        </div>

        <button @click.stop="send" class="btn btn-sm btn-block btn-info">
            ENVIAR SAIDAS <i class="fa fa-step-forward"></i>
        </button>
        <br/>
    </div>
</template>

<script>
    import Switche from '../../components/Switche';
    import {Bus} from '../../class/bus';
    import {Comandos} from "../../class";
    export default {
        name: "EnviarSaidas",
        components: {
            Switche
        },
        props: {
            id_rastreador: {
                "default": null
            },
            enable_output2: {
                "default": true
            }
        },
        data () {
            return {
                data:{
                    output1: false,
                    output2: false
                }
            }
        },
        methods: {
            async send () {
                await Comandos.output1(this.id_rastreador, this.data.output1);
                if (this.enable_output2) {
                    await Comandos.output2(this.id_rastreador, this.data.output2);
                }
                Bus.$emit('comandos');
            }
        }
    }
</script>

<style scoped>
.list-group-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.material-switch {
    display: flex;
    align-items: center;
}
</style>
